
import './surveyForm.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import menuLayout from '../../directive/menu-layout';
import survey from '../../service/survey';

import routing from './surveyForm.routes';
import SurveyFormController from './surveyForm.controller';

export default angular.module('page.surveyForm', [
		uirouter,
		menuLayout,
		'uiSwitch',

		survey,
		user
	])
	.config(routing)
	.controller('SurveyFormController', SurveyFormController)
	.name;



// WEBPACK FOOTER //
// ./src/page/surveyForm/index.js